import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

export const resourceModificationDataSlice = createSlice({
  name: 'resourceModificationData',
  initialState,
  reducers: {
    resourceModificationData: (state, action) => {
      return action.payload;
    },
    clearResourceModificationData: (state, action) => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { resourceModificationData, clearResourceModificationData } =
  resourceModificationDataSlice.actions;

export default resourceModificationDataSlice.reducer;
